import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//Models
import { CompleteRegistrationModel, GetClientDetailsResponseModel, UpdateClientContactDetailsRequestModel, GetClientControlOptionsResponseModel, RegisterNewClientRequestModel, GetClientFinaliseAccountDetailsResponseModel, FinaliseAccountRequestModel, RegisterNewClientResponseModel } from '../models/user.models';

//Other
import { environment } from '../../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { RegisterForManagedStorageRequestModel } from '../models/managed-storage.models';

@Injectable({
    providedIn: 'root'
})

export class UserManagementService {
    private searchEvent = new Subject<any>();
    private clientAccountDetailsPromise: Promise<GetClientDetailsResponseModel>

    searchEvent$ = this.searchEvent.asObservable();

    private get baseApiUrl(): string {
        return environment.userManagementUrl;
    }

    constructor(private http: HttpClient) {
    }

    getRegistrationPrefillData(): Observable<GetClientFinaliseAccountDetailsResponseModel> {
        const url = `${this.baseApiUrl}/v1/WinePortal/finaliseAccount`;
        return this.http.get<GetClientFinaliseAccountDetailsResponseModel>(url);
    }

    finaliseAccountDetailsV1(model: FinaliseAccountRequestModel): Observable<void> {
        const url = `${this.baseApiUrl}/v1/WinePortal/finaliseAccount`;
        return this.http.put<void>(url, model);
    }

    getClientAccountDetailsV1(): Observable<GetClientDetailsResponseModel> {
        const url = `${this.baseApiUrl}/v1/WinePortal/client`;
        return this.http.get<GetClientDetailsResponseModel>(url, {});
    }

    updateClientContactDetailsV1(model: UpdateClientContactDetailsRequestModel): Observable<void> {
        const url = `${this.baseApiUrl}/v1/WinePortal/client`;
        return this.http.put<void>(url, model);
    }

    createClientAccountV1(model: RegisterNewClientRequestModel): Observable<RegisterNewClientResponseModel> {
        const url = `${environment.authUrl}/Signup`;
        return this.http.post<RegisterNewClientResponseModel>(url, model);
    }

    getClientControlOptionsV1(): Observable<GetClientControlOptionsResponseModel> {
        const url = `${this.baseApiUrl}/v1/WinePortal/client/controlOptions`;
        return this.http.get<GetClientControlOptionsResponseModel>(url, {});
    }

    registerForManagedStorageV1(model: RegisterForManagedStorageRequestModel): Observable<void> {
        const url = `${this.baseApiUrl}/v1/WinePortal/registerForManagedStorage`;
        return this.http.put<void>(url, model);
    }

    clientAccountDetails(): Promise<GetClientDetailsResponseModel> {
        if (!this.clientAccountDetailsPromise) {
            this.clientAccountDetailsPromise = this.getClientAccountDetailsV1()
                .toPromise()
                .catch(() => null);
        }

        return this.clientAccountDetailsPromise;
    }
}